const pictures = [
    {
      src: require('./climbing.png'),
      title: 'Rock climbing /"Career"/',
      description: 'Enjoying a day of rock climbing.'
    },
    {
      src: require('./3rdPlace.jpeg'),
      title: '3rd Place',
      description: 'The day I won $9.00 playing Guilty Gear in Syracuse @AttackFromAllSides.'
    },
    {
      src: require('./gradPhoto.jpg'),
      title: 'Graduation',
      description: 'Pictured: My Brother, Sister and Myself (not pictured, the other brother who did not feel like showing up)'
    },
    {
      src: require('./dog.jpg'),
      title: 'Griffin',
      description: 'Pictured: Griffin, my childhood dog & Tim, my mothers chihuahua'
    }
  ];

export default pictures;